export default class y {
  constructor() {}
  Ns(a) {}
  changeUser(a = !1) {}
  clearData(a = !1) {}
}
